// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';


class AddTournament extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      venues: [],
      sub_categories: {},
      game_types: [],
      categories: {},
      age_groups: [],
      game_formats: [],
      tournament_details: {
        venue: '',
        name: '',
        game_type: '',
        start_date: moment(),
        end_date: moment(),
        registration_end: moment(),
        category: '',
        sub_category: '',
        age_groups: [],
        banner: '',
        game_formats: [],
        description: '',
        format_desc: '',
        prize_and_perks: '',
        registration_amount: '',
        registration_contact_number: '',
        online_registration_enabled: false,
        pay_later: false
      },
      data_uploaded: false,
      data_error: false,
      search: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleStartDate = this.handleStartDate.bind(this);
    this.handleEndDate = this.handleEndDate.bind(this);
    this.handleFile = this.handleFile.bind(this);
    this.handleRegDate = this.handleRegDate.bind(this);
    this.handleMultiselect = this.handleMultiselect.bind(this);
    this.handleCheck = this.handleCheck.bind(this);

  }


  componentDidMount() {
    this.getTournamentDetails();
    console.log(this.state);
  }

  getTournamentDetails() {
     const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_add_tournament/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
         this.setState(
         { venues: data.venues,
           sub_categories: data.sub_categories,
           game_types: data.game_types,
           categories: data.categories,
           age_groups: data.age_groups, 
           game_formats: data.game_formats,
         });
        })
       .catch(error => error);
  }

  postaddTournamentMember(data, props) {
    if(!data.venue){data.venue=this.state.venues[0].id}
    if(!data.game_type){data.game_type=this.state.game_types[0].pk}
    if(!data.category){data.category=Object.keys(this.state.categories)[0]}
    if(!data.sub_category){data.sub_category=Object.keys(this.state.sub_categories)[0]}  
    console.log(data);
    const url = `${getLocationOrigin()}/eagleeye/add_tournament/`;
    const options = {...defaultOptions};
    var formData = new FormData();
    for(var name in data) {
      formData.append(name, data[name]);
    }
    options['method'] = 'post';
    options['body'] = formData;
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                      // first then()
          alert(response.message);
          props.history.goBack();
        })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }

  handleChange(event) {
    const name = event.target.name;
    var new_selected_one =  Object.assign({}, this.state.tournament_details);
    new_selected_one[name] = event.target.value
    this.setState({tournament_details: new_selected_one});
  }
  handleMultiselect(event) {
    console.log(event);
    const name = event.target.name;
    var options = event.target.options;
    var new_selected_one =  Object.assign({}, this.state.tournament_details);
    var ids = []

    if(event){
       for (var i = 0, l = options.length; i < l; i++) {
      console.log(new_selected_one[name]);
              if (options[i].selected) {
                ids.push(options[i].value);
              }
          }
    }
    else{}
     new_selected_one[name] = ids; 
    this.setState({tournament_details: new_selected_one});
  }

  handleStartDate(date){
    var new_selected_one =  Object.assign({}, this.state.tournament_details);
    new_selected_one['start_date'] = date
    this.setState({tournament_details: new_selected_one});
  }
  handleEndDate(date){
    var new_selected_one =  Object.assign({}, this.state.tournament_details);
    new_selected_one['end_date'] = date
    this.setState({tournament_details: new_selected_one});
  }

  handleRegDate(date){
    var new_selected_one =  Object.assign({}, this.state.tournament_details);
    new_selected_one['registration_end'] = date
    this.setState({tournament_details: new_selected_one});
  }

  handleFile(selectorFiles: FileList){
    var new_selected_one =  Object.assign({}, this.state.tournament_details);
    console.log('Fileeeee');
    console.log(selectorFiles);
    new_selected_one['banner'] = selectorFiles[0]
    this.setState({tournament_details: new_selected_one});
  }

  handleCheck(event){
    console.log(event.target.name + event.target.checked)
    const name = event.target.name;
    var new_selected_one =  Object.assign({}, this.state.tournament_details);
    new_selected_one[name] = event.target.checked
    this.setState({tournament_details: new_selected_one});

  }

  handleSubmit(event) {
    event.preventDefault();
    this.postaddTournamentMember(this.state.tournament_details, this.props);
    console.log('post');
    console.log(this.state);
  }

  render() {
     console.log(this.state.tournament_details);
    return(
      <div style={styles.container}>
        <div className="row col-md-8 table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>Add Event</h3>
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Event Name *
              </div>
              <input type="text" style={styles.input} name="name" className="required"
                value={this.state.value} onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Venue *
              </div>
              <select name="venue" className="col-md-6" style={styles.item_body} value={this.state.value}
                onChange={this.handleChange}>
                {
                  this.state.venues.map((x, index) => (
                  <option key={x.id} value={x.id}>{x.name}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Game Type *
              </div>
              <select name="game_type" className="col-md-6" style={styles.item_body} value={this.state.value}
                onChange={this.handleChange}>
                {
                  this.state.game_types.map((x, index) => (
                  <option key={x.pk} value={x.pk}>{x.game + " : " + x.name}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Event Category
              </div>
              <select name="category" className="col-md-6" style={styles.item_body} value={this.state.value}
                onChange={this.handleChange}>
                {
                  Object.keys(this.state.categories).map((key, index) => (
                  <option key={index} value={key}>{this.state.categories[key]}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Event Sub-Category
              </div>
              <select name="sub_category" className="col-md-6" style={styles.item_body} value={this.state.value}
                onChange={this.handleChange}>
                {
                  Object.keys(this.state.sub_categories).map((key, index) => (
                  <option key={index} value={key}>{this.state.sub_categories[key]}</option>
                  ))
                }
              </select>
            </div>

             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Age Group
              </div>
              <select name="age_groups" id="age_group" className="col-md-6" style={styles.item_body} value={this.state.value} multiple={true}
                onChange={this.handleMultiselect}>
                {
                  this.state.age_groups.map((age_group, index) => (
                  <option key={index} value={age_group.id}>{age_group.name}</option>
                  ))
                }
              </select>
              <small className="pull-right">* use &lt;Ctrl&gt; for multiple selection</small>
            </div>

             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Game Format
              </div>
              <select name="game_formats" className="col-md-6" style={styles.item_body} value={this.state.value} multiple={true}
                onChange={this.handleMultiselect}>
                {
                  this.state.game_formats.map((game_format, index) => (
                  <option key={index} value={game_format.id}>{game_format.name}</option>
                  ))
                }
              </select>
              <small className="pull-right">* use &lt;Ctrl&gt; for multiple selection</small>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Banner *
              </div>
              <input type="file" style={styles.input} name="banner" onChange={ (e) => this.handleFile(e.target.files) }/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Start Date
              </div>
              <DatePicker selected={this.state.tournament_details.start_date} onChange={this.handleStartDate}/>
            </div>

             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                End Date
              </div>
              <DatePicker selected={this.state.tournament_details.end_date} onChange={this.handleEndDate}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Registration End Date
              </div>
              <DatePicker selected={this.state.tournament_details.registration_end} onChange={this.handleRegDate}/>
            </div>

        
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Registration Contact Number
              </div>
              <input type="number" style={styles.input} name="registration_contact_number" className="required"
                value={this.state.value} onChange={this.handleChange}/>
            </div>
             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Description
              </div>
              <textarea rows="4" cols="33" style={styles.input} id="description" name="description" placeholder="Description"
                onChange={this.handleChange}>
                {this.state.tournament_details.description}
                </textarea>
            </div>
             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Format desc
              </div>
              <textarea rows="4" cols="33" style={styles.input} id="format_desc" name="format_desc" placeholder="Format"
                  onChange={this.handleChange}>
                  {this.state.tournament_details.format_desc}
                </textarea>
            </div>
             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Prize and perks
              </div>
              <textarea  rows="2" cols="33" style={styles.input} id="prize_and_perks" name="prize_and_perks" placeholder="Prize" onChange={this.handleChange}>
               {this.state.tournament_details.prize_and_perks}
                </textarea>
            </div>
             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Default Amount *
              </div>
             <input type="number" style={styles.input} name="registration_amount" className="required"
                value={this.state.value} onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Online Registration
              </div>
             <input type="checkbox"
                    checked={this.state.tournament_details.online_registration_enabled}
                    ref="online_registration_enabled"
                    name="online_registration_enabled"
                    onChange={this.handleCheck}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Free Event
              </div>
             <input type="checkbox"
                    checked={this.state.tournament_details.pay_later}
                    ref="pay_later"
                    name="pay_later"
                    onChange={this.handleCheck}/>
            </div>

            <div style={styles.button_submit} className="col-md-12">

              <input className="btn btn-lg" type="submit" value="Submit" style={{backgroundColor:'#302C35',
                color:'#ffffff'}}/>
                <p className="pull-right">* Fields are Mandatory!!</p>
            </div>
            <div className="col-md-12">
              {this.state.data_uploaded?<div className="text-success" style={styles.success}>* Fixture created successfully.</div>:''}
              {this.state.data_error?<div className="text-danger" style={styles.success}>* Error, creation failed.</div>:''}
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default AddTournament;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addTournament/index.js